import React from "react";
import { ArticleTileProps } from "../../types/article-tile";
import { RecommendationType } from "../../types/articles";
import ArticleImage from "../article-image/article-image";
import ArticleInfo from "../article-info/article-info";
import CategoryButton from "../category-button/category-button";
import OrderModalButton from "../order-modal-button/order-modal-button";
import "./article-tile.scss";

const ArticleTile = (props: ArticleTileProps) => {
  const itemOrigin = `RECO_${props.article.recommendationType}_${props.pageLocation}`
    .replaceAll("-", "_")
    .toUpperCase();
  const modelVersionPlaceholder = "1.0"; // replace with model version when available
  const productRecoModel = (
    props.article.recommendationType === RecommendationType.Model
      ? `${props.article.recommendationType}-${modelVersionPlaceholder}`
      : props.article.recommendationType
  ).toLowerCase();

  return (
    <div
      className="article-tile"
      data-testid={`article-tile-${props.article.slot}`}
      data-semantic-id="product-recommendation-tile"
      data-product-recommendation-tile-index={props.article.slot}
      data-product-recommendation-fragment={props.dataFragmentName}
      data-product-recommendation-model={productRecoModel}
      data-master-article-no={props.article.masterArticleNo}
      data-sales-article-no={props.article.salesArticleNo}
      data-color-code={props.article.colorCode}
      data-size-code={props.article.sizeCode}
      data-item-origin={itemOrigin}
      data-category-name={props.article.categoryName}
    >
      <ArticleImage
        article={props.article}
        l10n={props.l10n}
        itemOrigin={itemOrigin}
        productRecoModel={productRecoModel}
        pageLocation={props.pageLocation}
        dataFragmentName={props.dataFragmentName}
      />

      <ArticleInfo
        article={props.article}
        currencyInformation={props.currencyInformation}
        l10n={props.l10n}
        itemOrigin={itemOrigin}
        productRecoModel={productRecoModel}
        pageLocation={props.pageLocation}
        dataFragmentName={props.dataFragmentName}
      />

      <div className="button-container">
        <OrderModalButton
          l10n={props.l10n}
          article={props.article}
          itemOrigin={itemOrigin}
          productRecoModel={productRecoModel}
          pageLocation={props.pageLocation}
          dataFragmentName={props.dataFragmentName}
        />
        <CategoryButton
          l10nMore={props.l10n.more}
          l10nMoreProducts={props.l10n.moreProducts}
          categoryLink={props.article.categoryLink}
          slot={props.article.slot}
          categoryName={props.article.categoryName}
          dataFragmentName={props.dataFragmentName}
          productRecoModel={productRecoModel}
        />
      </div>
    </div>
  );
};

export default ArticleTile;
